module.exports = __webpack_public_path__ + "img/tk-back.5cadfcd5.png";